import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeaturesMediaIfDirective } from './directives/if-media/if-media.directive';

@NgModule({
  declarations: [FeaturesMediaIfDirective],
  exports: [FeaturesMediaIfDirective],
  imports: [CommonModule],
})
export class CoreFeaturesMediaIfModule {}
